module.exports = "../fonts/n-a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/n-a.eot
// module id = 4fv2
// module chunks = 1